// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedAuthProvider {
  dmm: {"enum_constant":"dmm"};
  dmm_staging: {"enum_constant":"dmm_staging"};
  dmm_test: {"enum_constant":"dmm_test"};
  facebook: {"enum_constant":"facebook"};
  password: {"enum_constant":"password"};
}

export type AuthProviderId = keyof IParsedAuthProvider;
export type AuthProviderData = IParsedAuthProvider[AuthProviderId];
const data: AuthProviderData[] = [{"enum_constant":"dmm"},{"enum_constant":"dmm_staging"},{"enum_constant":"dmm_test"},{"enum_constant":"facebook"},{"enum_constant":"password"}];
export default data;
